.nav {
  position: sticky;
  top: 0;
  z-index: 1;
}

/* Desktop */
@media (min-width: 1024px) {
  .nav {
    display: none;
  }
}
